@if (campaignLink$ | async; as campaignLink) {
  @if (visibility$ | async) {
    @if (isNewBrand()) {
      <fcom-banner
        [theme]="NotificationTheme.PROMOTION"
        [blackFriday]="campaignLink.enableBlackTeaser"
        [linkText]="campaignLink.text"
        [linkUrl]="campaignLink.link.url"
        [gtmTrackingLabel]="'campaign-banner'"
        [gtmTrackingContext]="GaContext.TOP_NAVIGATION"
        [isCampaign]="true"
        data-testid="campaign-banner-link"
      ></fcom-banner>
    } @else {
      <div
        class="campaign-banner"
        [class.black-bg]="campaignLink.enableBlackTeaser"
        [class.surface-contrast]="campaignLink.enableBlackTeaser"
        [class.heather-700-bg]="!campaignLink.enableBlackTeaser"
        [class.surface-accent]="!campaignLink.enableBlackTeaser"
      >
        <div class="grid-col-12 grid-max-width">
          <div class="align-center col-1-12">
            <a
              [finLink]="campaignLink.link.url"
              [finElemTracker]="'campaign-banner'"
              [finElemContext]="'top-navigation'"
              [finElemType]="ElementTypes.BANNER"
              class="grey-25-text text-icon-reversed ps-xsmall inline-block mr-medium-x font-body-medium-bold"
              data-testid="campaign-banner-link"
            >
              {{ campaignLink.text }}
            </a>
          </div>
        </div>
      </div>
    }
  }
}
